import React from "react";
import ReactDOM from "react-dom";

function Header() {
  return (
    <header>
      <h1>Keeper</h1>
    </header>
  );
}

export default Header;
